<div class="staticPage">
  <h1 class="blueColor">{{ 'about_us' | translate }}</h1>
  <div class="gradientDivider"></div>
  <div class="content-from-editor" [innerHTML]="aboutUsHtml"></div>
</div>
